import { flsModules } from "../files/modules.js";

import Swiper from "swiper";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";

import { Fancybox } from "@fancyapps/ui";

const heroSlider = document.querySelector('.hero__slider');

if (heroSlider) {
  const heroPagination = heroSlider.querySelector('.hero__pagination');

  new Swiper(heroSlider, {
    modules: [Autoplay, EffectFade, Pagination],
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    effect: 'fade',
    allowTouchMove: false,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination: {
      el: heroPagination,
      clickable: true,
    },
  });
}